<template>
  <div id="payment-and-refill" :class="this.$lang === 'ar' ? 'regular-ar' : 'regular-en'">
    <div class="header-container position-relative">
      <div id="mobile" class="mobile">
        <img :src="background" />
        <div v-observe-visibility="visibilityChanged"></div>
      </div>
      <div  style="left: 6.5px" class="background">
        <vue-lottie-player :key="key"  name="anime" ref="lottie" width="100%" height="auto" :animationData="pay1" />
      </div>
      <div class="background">
        <vue-lottie-player :key="key + 1"  name="anime" ref="lottie" width="100%" height="auto" :animationData="pay2" />
      </div>
      <div class="inner-container d-flex">
        <div class="header-titles position-relative">
          <div class="header-data">
            <div :class="['header-title', this.$lang === 'ar' ? 'bold-italic-ar' : 'bold-italic-en']">{{$t('paymentAndRefill.title')}}</div>
<!--            <div :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en', 'description']">{{desc}}</div>-->
          </div>
        </div>
      </div>
    </div>
    <div class="main-content">
      <div class="content-header">
        <div :class="[this.$lang === 'ar' && 'rotate right-dir', 'tabs-container']" style="width: 100%">
          <v-tabs
            v-model="tab"
            grow
            centered
            show-arrows
            class="line-tabs left-dir"
          >
            <v-tabs-slider color="#FFCB05" ></v-tabs-slider>
            <v-tab
              v-for="item in info.items" :key="item.title" :active-class="lang === 'ar' ? 'bold-italic-ar' : 'bold-italic-en'">{{ item.title }}
            </v-tab>
          </v-tabs>
        </div>
      </div>
      <div v-if="load || error" class="response-handle">
        <Loader v-if="load" />
        <Error v-if="error" />
      </div>
      <v-tabs-items v-model="tab" :touchless="true">
        <div class="products-container">
          <v-tab-item v-for="item in info.items" :key="item.title">
            <component :is="item.comp" :additionalInfo="item.additionalInfo" :lineCard="item.lineCard" />
          </v-tab-item>
        </div>
      </v-tabs-items>
    </div>
  </div>
</template>
<script>
import PaymentAndRefillContent from './PaymentAndRefillContent'
import ProductsCategories from '../../repositories/ProductsCategories'
import VueLottiePlayer from 'vue-lottie-player'
import pay1 from '../../assets/json/1pay.json'
import pay2 from '../../assets/json/2pay.json'
import background from '../../assets/images/mobileBackground.png'
import Loader from '../../components/LoaderBtn/Loader'
import Error from '../../components/errorHandle/Error'
import $ from 'jquery'
export default {
  components: { PaymentAndRefillContent, VueLottiePlayer, Loader, Error },
  data () {
    return {
      background: background,
      pay1,
      pay2,
      key: 0,
      productsCategoryRepo: new ProductsCategories(0),
      tab: null,
      info: { items: [] },
      activeId: null,
      lang: this.$lang,
      desc: '',
      load: false,
      error: false
    }
  },
  created () {
    this.activeId = this.$route.params.type
    this.fetchData()
  },
  mounted () {
    this.$lang === 'ar' && $('#payment-and-refill .v-tab').css('transform', 'rotateY(180deg)')
  },
  watch: {
    tab (val) {
      this.$store.state.productsInnerTab = val
    }
  },
  methods: {
    visibilityChanged (isVisible) {
      if (isVisible) {
        this.key++
        this.$forceUpdate()
      }
    },
    checkActiveTab (items, active) {
      return items.findIndex(o => o.id === Number(active))
    },
    async fetchData () {
      this.load = true
      try {
        const response = await this.productsCategoryRepo.get()
        if (response.status === 200) {
          this.desc = response.data.description
          for (let i = 0; i < response.data.serviceFeatures.length; i++) {
            this.info.items.push({
              id: response.data.serviceFeatures[i].id,
              title: response.data.serviceFeatures[i].title,
              comp: 'PaymentAndRefillContent',
              lineCard: response.data.serviceFeatures[i].html,
              additionalInfo: response.data.serviceFeatures[i].featureInfos
            })
          }
          if (this.activeId !== null) {
            // Search for for example prices list tab via id
            this.tab = this.checkActiveTab(this.info.items, this.activeId)
          }
        } else {
          this.error = true
        }
      } catch (e) {
        this.error = true
        console.log(e)
      }
      this.load = false
      setTimeout(() => {
        this.$lang === 'ar' && $('#payment-and-refill .v-tab').css('transform', 'rotateY(180deg)')
        this.$lang === 'ar' ? $('.v-tab').css('direction', 'rtl') : $('.v-tab').css('direction', 'ltr')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "src/assets/sass/modules/products";
.mobile {
    width: 8.75%;
    height: 85%;
    right: 7.3%;
    position: absolute;
    bottom: -10px;
    max-height: 318px
}
.mobile > img {
  height: 100%;
  width: 100%
}
.background{
  position:absolute;
  height: 100%;
  width: 100%;
  bottom: -8px;
}
.rotate{
  transform: rotateY(180deg) !important;
}
.description{
  width: 100%; margin: 0 auto; text-align: center;
}
.left{
  left: 0px
}
.right{
  right: 0px;
}
.header-container{
  width: 100%;
  min-height: 350px;
  text-align: initial;
  position: relative;
  z-index: 0;
}
.inner-container{
  background-image: url("../../assets/images/yellow.png");
  background-size: cover;
  min-height: 350px;
  position: relative;
  z-index: -2;
  .header-titles{
    padding-bottom: 40px;
    width: 50%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .header-data{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 20px 0
    }
    .header-title{
      color: #fff;
      font-size: 30px;
    }
  }
}
.response-handle{
  min-height: calc(100vh - ( 400px + 170px));
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 1230px) {
  img.header-img {
    height: 300px;
    width: 300px;
    bottom: 0;
    top: unset;
  }
}

@media screen and (max-width: 1000px){
  .inner-container{
    padding-top: 0;
    min-height: 350px
  }
  .header-titles{
    width: 90% !important;
  }
  img.header-img{
    display: block;
    position: unset;
    margin: 0 auto;
  }
}
/*------------------------------- responsive json file ---------------------------*/
@media (min-width: 1100px) {
  .description{
    padding-top: 20px !important;
  }
  .header-container{
    min-height: 300px
  }
  .inner-container{
    min-height: 300px
  }
}
@media (min-width: 1250px) {
  .header-container{
    min-height: 330px
  }
  .inner-container{
    min-height: 330px
  }
}
@media (min-width: 1500px) {
  .inner-container,
  .header-container{
    min-height: 350px
  }
  //.mobile{
  //  bottom: -20px;
  //}
  //.background{
  //  bottom: -25px;
  //}
}
@media (min-width: 1600px) {
  .inner-container,
  .header-container{
    min-height: 370px
  }
  //.mobile{
  //  bottom: -20px;
  //}
  //.background{
  //  bottom: -20px
  //}
}
@media (min-width: 1800px) {
  .inner-container,
  .header-container{
    min-height: 400px
  }
  //.mobile{
  //  bottom: 0px;
  //}
  //.background{
  //  bottom: -20px
  //}
}
@media (min-width: 1900px) {
  .inner-container,
  .header-container{
    min-height: 420px
  }
  .mobile{
    bottom: 0px;
    min-height: 330px
  }
  //.background{
  //  bottom: -20px
  //}
}
@media (min-width: 2000px) {
  //.mobile{
  //  bottom: -5px
  //}
}
@media (max-width: 1280px){
  .header-titles{
    display: block;
  }
  .center{
    padding-bottom: 20px
  }
  .background,
  .mobile{
    display: none
  }
}
@media (min-width: 2200px){
  .background,
  .mobile{
    display: none
  }
}
/*----------------------------------------------------------------------*/
</style>
<style lang="scss">
#payment-and-refill{
  .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active){
    color: rgba(29, 29, 29, 0.6) !important;
  }
  .v-tabs{
    height: 100%;
    border: none !important;
  }
  .v-tab{
    font-size: 12px !important;
    border-bottom: 2px solid #ffffff;
    text-transform: capitalize;
  }
  .v-tab.v-tab--active{
    color: #FFCB05;
  }
  .v-window.v-item-group.theme--light.v-tabs-items{
    background: transparent;
  }
}
</style>
